<script>
    export default {
        name: "FooterFeedback",
        props: {
            hasBackground: {
                type: Boolean,
                default: true,
            },
        },
        computed: {
            backgroundImage() {
                if (this.hasBackground) {
                    return {
                        backgroundImage: `url('/static/${this.$root.$_name}/footer/feedback.png')`,
                    };
                }
                return {};
            },
        },
    };
</script>

<template>
    <div class="footer-feedback" :style="backgroundImage">
        <div class="footer-feedback__title">
            Давайте <br v-if="hasBackground" />
            сотрудничать
        </div>
        <div class="footer-feedback__text">
            Реклама, оптовые <br />
            и&nbsp;корпоративные&nbsp;заказы
        </div>

        <button
            class="footer-feedback__button outline"
            @click="$popup.show('modal-feedback-footer')"
        >
            Заполнить форму
        </button>
    </div>
</template>

<style lang="scss">
    .footer-feedback {
        padding: var(--footer-feedback-padding);
        border-radius: var(--footer-feedback-radius);
        background-color: var(--footer-feedback-background);
        background-size: cover;
        background-position: center;
    }

    .footer-feedback__title {
        margin-bottom: 15px;
        color: var(--footer-feedback-title-color);
        font-family: var(--footer-feedback-title-font);
        font-size: var(--footer-feedback-title-size);
        font-weight: var(--footer-feedback-title-weight);
        line-height: 36px;
    }

    .footer-feedback__text {
        margin-bottom: 25px;
        color: var(--footer-feedback-text-color);
        font-size: var(--footer-feedback-text-size);
        font-weight: var(--footer-feedback-text-weight);
        line-height: 22px;
    }

    .footer-feedback__button {
        width: 100%;
        padding: 13px 26px;
        color: var(--footer-feedback-button-color);
        font-family: var(--footer-feedback-button-font);
        font-size: 18px;
        font-weight: var(--footer-feedback-button-weight);
        line-height: 22px;
        background-color: var(--footer-feedback-button-background);
        border-radius: var(--footer-feedback-button-radius);
        transition: color 0.2s ease-in, background-color 0.2s ease-in,
            border-color 0.2s ease-in;
        &:hover {
            color: var(--footer-feedback-button-color--hover);
            background-color: var(--footer-feedback-button-background--hover);
        }
        @include bp($bp-desktop-sm) {
            width: auto;
        }
    }
</style>
